export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7015.8b1f3338.jpg";